module.exports = __webpack_public_path__ + "static/media/3.Mini Weeder.e42ea7a4.jpeg";